var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyElementBase, SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var SurveyQuestionImagePicker = /** @class */ (function (_super) {
    __extends(SurveyQuestionImagePicker, _super);
    function SurveyQuestionImagePicker(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionImagePicker.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionImagePicker.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        return (React.createElement("fieldset", { className: this.question.getSelectBaseRootCss(), style: this.question.getContainerStyle() },
            React.createElement("legend", { className: "sv-hidden" }, this.question.locTitle.renderedHtml),
            this.question.hasColumns ? this.getColumns(cssClasses) : this.getItems(cssClasses)));
    };
    SurveyQuestionImagePicker.prototype.getColumns = function (cssClasses) {
        var _this = this;
        return this.question.columns.map(function (column, ci) {
            var items = column.map(function (item, ii) {
                return _this.renderItem(item, cssClasses);
            });
            return (React.createElement("div", { key: "column" + ci + _this.question.getItemsColumnKey(column), className: _this.question.getColumnClass(), role: "presentation" }, items));
        });
    };
    SurveyQuestionImagePicker.prototype.getItems = function (cssClasses) {
        var items = [];
        for (var i = 0; i < this.question.visibleChoices.length; i++) {
            var item = this.question.visibleChoices[i];
            items.push(this.renderItem(item, cssClasses));
        }
        return items;
    };
    Object.defineProperty(SurveyQuestionImagePicker.prototype, "textStyle", {
        get: function () {
            return { marginLeft: "3px", display: "inline", position: "static" };
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionImagePicker.prototype.renderItem = function (item, cssClasses) {
        var renderedItem = React.createElement(SurveyQuestionImagePickerItem, { key: item.uniqueId, question: this.question, item: item, cssClasses: cssClasses });
        var survey = this.question.survey;
        var wrappedItem = null;
        if (!!survey) {
            wrappedItem = ReactSurveyElementsWrapper.wrapItemValue(survey, renderedItem, this.question, item);
        }
        return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
    };
    return SurveyQuestionImagePicker;
}(SurveyQuestionElementBase));
export { SurveyQuestionImagePicker };
var SurveyQuestionImagePickerItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionImagePickerItem, _super);
    function SurveyQuestionImagePickerItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    SurveyQuestionImagePickerItem.prototype.getStateElement = function () {
        return this.item;
    };
    SurveyQuestionImagePickerItem.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.reactOnStrChanged();
    };
    SurveyQuestionImagePickerItem.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.item.locImageLink.onChanged = function () { };
    };
    SurveyQuestionImagePickerItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.reactOnStrChanged();
    };
    SurveyQuestionImagePickerItem.prototype.reactOnStrChanged = function () {
        var _this = this;
        this.item.locImageLink.onChanged = function () {
            _this.setState({ locImageLinkchanged: !!_this.state && _this.state.locImageLink ? _this.state.locImageLink + 1 : 1 });
        };
    };
    Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "cssClasses", {
        get: function () {
            return this.props.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionImagePickerItem.prototype.handleOnChange = function (event) {
        if (this.question.isReadOnlyAttr)
            return;
        if (this.question.multiSelect) {
            if (event.target.checked) {
                this.question.value = this.question.value.concat(event.target.value);
            }
            else {
                var currValue = this.question.value;
                currValue.splice(this.question.value.indexOf(event.target.value), 1);
                this.question.value = currValue;
            }
        }
        else {
            this.question.value = event.target.value;
        }
        this.setState({ value: this.question.value });
    };
    SurveyQuestionImagePickerItem.prototype.renderElement = function () {
        var _this = this;
        var item = this.item;
        var question = this.question;
        var cssClasses = this.cssClasses;
        var isChecked = question.isItemSelected(item);
        var itemClass = question.getItemClass(item);
        var text = null;
        if (question.showLabel) {
            text = (React.createElement("span", { className: question.cssClasses.itemText }, item.text ? SurveyElementBase.renderLocString(item.locText) : item.value));
        }
        var style = { objectFit: this.question.imageFit };
        var control = null;
        if (item.locImageLink.renderedHtml && this.question.contentMode === "image") {
            control = (React.createElement("img", { className: cssClasses.image, src: item.locImageLink.renderedHtml, width: this.question.renderedImageWidth, height: this.question.renderedImageHeight, alt: item.locText.renderedHtml, style: style, onLoad: function (event) { _this.question["onContentLoaded"](item, event.nativeEvent); }, onError: function (event) { item.onErrorHandler(item, event.nativeEvent); } }));
        }
        if (item.locImageLink.renderedHtml && this.question.contentMode === "video") {
            control = (React.createElement("video", { controls: true, className: cssClasses.image, src: item.locImageLink.renderedHtml, width: this.question.renderedImageWidth, height: this.question.renderedImageHeight, style: style, onLoadedMetadata: function (event) { _this.question["onContentLoaded"](item, event.nativeEvent); }, onError: function (event) { item.onErrorHandler(item, event.nativeEvent); } }));
        }
        if (!item.locImageLink.renderedHtml || item.contentNotLoaded) {
            var style_1 = {
                width: this.question.renderedImageWidth,
                height: this.question.renderedImageHeight,
                objectFit: this.question.imageFit
            };
            control = (React.createElement("div", { className: cssClasses.itemNoImage, style: style_1 }, cssClasses.itemNoImageSvgIcon ?
                React.createElement(SvgIcon, { className: cssClasses.itemNoImageSvgIcon, iconName: this.question.cssClasses.itemNoImageSvgIconId, size: 48 }) :
                null));
        }
        var renderedItem = (React.createElement("div", { className: itemClass },
            React.createElement("label", { className: cssClasses.label },
                React.createElement("input", { className: cssClasses.itemControl, id: this.question.getItemId(item), type: this.question.inputType, name: this.question.questionName, checked: isChecked, value: item.value, disabled: !this.question.getItemEnabled(item), readOnly: this.question.isReadOnlyAttr, onChange: this.handleOnChange, required: this.question.inputRequiredAttribute, "aria-label": item.locText.renderedHtml, "aria-invalid": this.question.ariaInvalid, "aria-errormessage": this.question.ariaErrormessage }),
                React.createElement("div", { className: this.question.cssClasses.itemDecorator },
                    React.createElement("div", { className: this.question.cssClasses.imageContainer },
                        !!this.question.cssClasses.checkedItemDecorator ?
                            React.createElement("span", { className: this.question.cssClasses.checkedItemDecorator, "aria-hidden": "true" }, !!this.question.cssClasses.checkedItemSvgIconId ? React.createElement(SvgIcon, { size: "auto", className: this.question.cssClasses.checkedItemSvgIcon, iconName: this.question.cssClasses.checkedItemSvgIconId }) : null) : null,
                        control),
                    text))));
        return renderedItem;
    };
    return SurveyQuestionImagePickerItem;
}(ReactSurveyElement));
export { SurveyQuestionImagePickerItem };
ReactQuestionFactory.Instance.registerQuestion("imagepicker", function (props) {
    return React.createElement(SurveyQuestionImagePicker, props);
});
